/*
 * action types
 */

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

/*
 * action creators
 */

export function openModal(content) {
  return {
    type: OPEN_MODAL,
    content
  };
}

export function closeModal() {
  return {
    type: CLOSE_MODAL
  };
}



// WEBPACK FOOTER //
// ./src/actions/modal.js